var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticClass: "header"
  }, [_c("el-alert", {
    staticClass: "tips",
    attrs: {
      title: "使用扫描枪",
      description: "请使用扫描枪获取函证编号或手工录入函证编号(扫描枪扫入将自动分隔, 手工录入请使用半角逗号分隔)",
      type: "error"
    }
  }), _c("el-form", {
    ref: "form",
    attrs: {
      model: _vm.form,
      "label-width": "80px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "函证单号"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      autosize: {
        minRows: 2,
        maxRows: 4
      },
      placeholder: "请录入函证单号,以英文逗号隔开"
    },
    model: {
      value: _vm.form.codes,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "codes", $$v);
      },
      expression: "form.codes"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "快递单号"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入快递单号"
    },
    model: {
      value: _vm.form.express,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "express", $$v);
      },
      expression: "form.express"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: ""
    }
  }, [_c("el-button", {
    attrs: {
      type: "primary",
      size: "small"
    },
    on: {
      click: _vm.toPrint
    }
  }, [_vm._v("打印")])], 1)], 1)], 1), _c("div", {
    staticClass: "table"
  }, [_c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    ref: "table",
    staticClass: "task-tree-table",
    staticStyle: {
      width: "100%"
    },
    attrs: {
      border: "",
      data: _vm.list,
      size: "mini",
      "row-key": "c02ConfirmCode"
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "函证编号",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.c02ConfirmCode) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "函证类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.c02Type) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "函证对象"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.c03ConfirmObj ? scope.row.c03ConfirmObj.c03CusName : "") + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "发函日期",
      width: "85"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(_vm._f("date")(scope.row.c02SendDate, "yyyy-MM-dd")) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "发函快递单号",
      width: "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.c02SendNumber) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "回函快递单号",
      width: "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.c02BackNumber) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "回函日期",
      width: "85"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(_vm._f("date")(scope.row.c02BackConfirmDate, "yyyy-MM-dd")) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "收件日期",
      width: "85"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(_vm._f("date")(scope.row.c02BackConfirmActualDate, "yyyy-MM-dd")) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "快递公司",
      width: "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.c02BackCompany) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "到付运费",
      width: "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.c02BackFee) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "回函寄件人",
      width: "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.c02BackSendName) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "回函寄件人联系电话",
      width: "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.c02BackSendMobile) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "收件地址",
      width: "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.c02BackAddress) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "回函检查说明",
      width: "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.c02BackConfirmExplain) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "领取状态",
      width: "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.c02GetStatus) + " ")];
      }
    }])
  })], 1)], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };